import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getCompanyDirectory } from "@tSchaedlerYesco/Services/CompanyDirectoryService";

type HandlerType = ApiHandlerDiscreteParameter<{ onSuccess?: (companyData: any) => void }, {}, any[]>;

export const PopulateCompanyDirectory: HandlerType = async props => {
    try {
        props.apiResult = await getCompanyDirectory();
        // eslint-disable-next-line no-empty
    } catch (error) {}
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult!);
};

export const chain = [PopulateCompanyDirectory, ExecuteOnSuccessCallback];

const loadCompanyDirectory = createHandlerChainRunner(chain, "LoadCompanyDirectory");
export default loadCompanyDirectory;
